import { render } from "./DesktopAuswahl.vue?vue&type=template&id=dc67634a&scoped=true"
import script from "./DesktopAuswahl.vue?vue&type=script&lang=js"
export * from "./DesktopAuswahl.vue?vue&type=script&lang=js"

import "./DesktopAuswahl.vue?vue&type=style&index=0&id=dc67634a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc67634a"]])

export default __exports__